import styled from 'styled-components'
import { ENTRANCE_BG, G } from '@/components/gold/theme'

/**
 * ver2(gold) 게임사 타일 — gold8.bet PC 실측(원본 × 1.2):
 *   타일 341×156(비율 284:130), 테두리 2px #ff8, 간격 25px, 한 줄 4개, 마지막 줄은 가운데 정렬.
 *   원본은 화면이 좁으면 4번째 줄이 잘리므로, 여기서는 본문 폭 안에서 4등분해 줄어들게 한다.
 */
export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 25px;
`

export const Tile = styled.div`
  position: relative;
  box-sizing: border-box;
  width: calc((100% - 75px) / 4);
  aspect-ratio: 284 / 130;
  border: 2px solid ${G.tileBorder};
  background: #070b10;
  overflow: hidden;

  &:hover > div:last-child { display: flex; }
`

export const TileBg = styled.div`
  width: 100%;
  height: 100%;
  img {
    display: block;
    width: 100%;
    height: 100%;
    /* gold: 340×130 타일 그림을 칸(284:130)에 100% 100% 로 늘려 그림 전체를 보여준다 — 자르지 않는다 */
    object-fit: fill;
  }
`

/** 마우스를 올리면 나오는 반투명 막 + 입구 버튼 */
export const Entrance = styled.div`
  position: absolute;
  inset: 0;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba(0, 0, 0, 0.5);
`

export const EntranceBtn = styled.button`
  width: 115px;
  height: 36px;
  border: 1px solid #fff7b5;
  border-radius: 14px;
  background: ${ENTRANCE_BG};
  font-size: 17px;
  line-height: 34px;
  color: #fff;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.8);
  cursor: pointer;
`
